/**
 * @Author: v_jppjpeng
 * @Date: 2024-08-16 17:04:26
 * @Explain: 活动 - 埋点事件
 */
export default {
  /** 创建、编辑活动 - 点击step1 - 确定 */
  200: 'clickCampaignsSenderConfirmButtonError',
  /** 创建、编辑活动 - 点击step2 - 确定 */
  201: 'clickCampaignsRecipientsConfirmButtonError',
  /** 创建、编辑活动 - 点击step3 - 确定 */
  202: 'clickCampaignsContentConfirmButtonError',
  /** 创建、编辑活动 - 点击step4 - 确定 */
  203: 'clickCampaignsDeliveryScheduleConfirmButtonError',
  /** 创建、编辑活动 - 点击保存并退出 */
  204: 'clickCampaignsSaveAndExitButton',
  /** 创建、编辑活动 - 点击保存并退出 - 提交错误 */
  205: 'clickCampaignsSaveAndExitError',
  /** 创建、编辑活动 - 点击发送测试邮件 - 提交错误 */
  206: 'clickCampaignsPreviewAndTestSendError',
  /** 创建、编辑活动 - 点击现在发送 */
  207: 'clickCampaignsLaunchNowButton',
  /** 创建、编辑活动 - 点击现在发送 - 提交错误 */
  208: 'clickCampaignsLaunchNowButtonError',
  /** 活动列表 - 删除错误 */
  209: 'clickDeleteCampaignsError',
};
